import * as React from 'react';
import {
  List,
  ListProps,
  Datagrid,
  TextField,
  useRecordContext,
  FieldProps,
  useTranslate,
} from 'react-admin';
import Paginator from '../../../components/Paginator';
import { TESTS_PER_PAGE } from '../../../constants/pagination';

const CONSULTATION_STEP_IDS = [
  'bookConsultationWithNutritionistOne',
  'bookConsultationWithNutritionistTwo',
  'bookConsultationWithNutritionistThree',
  'bookConsultationWithNutritionistFour',
  'bookConsultationWithNutritionistFive',
  'bookConsultationWithNutritionistSix',
  'bookConsultationWithNutritionistSeven',
];

const LastStepField = ({ label: _label }: FieldProps) => {
  const translate = useTranslate();
  const record = useRecordContext();

  const lastCompletedStep = CONSULTATION_STEP_IDS.slice()
    .reverse()
    .find((id) =>
      record?.steps?.find(
        (s: any) => s.id === id && s.status === 'completed',
      ),
    );

  if (!lastCompletedStep) return <span>-</span>;

  return <span>{translate(`treatments.steps.${lastCompletedStep}`)}</span>;
};

const CompletedAtField = ({ label: _label }: FieldProps) => {
  const record = useRecordContext();

  const lastCompletedStep = CONSULTATION_STEP_IDS.slice()
    .reverse()
    .map((id) => record?.steps?.find((s: any) => s.id === id && s.status === 'completed'))
    .find(Boolean);

  const completedAt = lastCompletedStep?.consultationData?.completedAt;
  if (!completedAt) return <span>-</span>;

  const formatted = new Date(completedAt).toLocaleDateString('de-CH');
  return <span>{formatted}</span>;
};

const ReviewedTreatmentsList = (props: ListProps) => (
  <List
    {...props}
    bulkActionButtons={false}
    actions={false}
    pagination={<Paginator perPage={TESTS_PER_PAGE} />}
    perPage={TESTS_PER_PAGE}
  >
    <Datagrid rowClick="show">
      <TextField source="userName" label="Name" sortable={false} />
      <LastStepField source="steps" label="Last Completed Step" />
      <CompletedAtField source="steps" label="Completed At" />
    </Datagrid>
  </List>
);

export default ReviewedTreatmentsList;
